"use client"

import { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

// Fetch policies for a specific group, optionally including its parent
export const useFetchPolicies = (groupId, includeParent = false) => {
  const [policies, setPolicies] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const fetchPolicies = async () => {
      if (!groupId) {
        setPolicies([])
        setLoading(false)
        return
      }

      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          },
        })

        const endpoint = includeParent
          ? `${apiUrl}/api/policies/GroupAndParentPolicies/${groupId}`
          : `${apiUrl}/api/policies/GroupPolicies/${groupId}`

        const response = await fetch(endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (!response.ok) {
          throw new Error(
            `Failed to fetch policies for group ${groupId}: ${response.statusText}`
          )
        }

        const data = await response.json()
        setPolicies(data)
      } catch (err) {
        console.error(
          `Error fetching policies for group ${groupId}:`,
          err.message
        )
        setPolicies([])
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    setLoading(true)
    setError(null)
    fetchPolicies()
  }, [groupId, includeParent, getAccessTokenSilently, apiUrl])

  return { policies, loading, error }
}
